/* SOLCOZM Fase 60 · barra d'acquisto fissa per smartphone.
   Non aggiunge mai al carrello da sola: rispecchia il pulsante originale [data-sc-pdp-add] e lo attiva. */
(function () {
  var bar = document.querySelector('[data-scs-bar]');
  var pdp = document.querySelector('[data-sc-product]');
  var main = pdp && pdp.querySelector('[data-sc-pdp-add]');
  if (!bar || !main) return;
  var btn = bar.querySelector('[data-scs-btn]');
  var label = bar.querySelector('[data-scs-label]');
  var priceOut = bar.querySelector('[data-scs-price]');
  var variantOut = bar.querySelector('[data-scs-variant]');
  var priceIn = pdp.querySelector('[data-sc-pdp-price]');
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mainVisible = true;
  var mode = 'add';

  function sizeGroup() {
    var opts = {};
    try { opts = JSON.parse((pdp.querySelector('[data-sc-pdp-options]') || {}).textContent || '{}'); } catch (e) {}
    var idx = parseInt(opts.sizeIndex, 10) || 0;
    return idx ? pdp.querySelector('[data-sc-pdp-option][data-option-index="' + idx + '"]') : null;
  }
  function selectedValues() {
    return Array.prototype.map.call(pdp.querySelectorAll('[data-sc-pdp-option] .is-selected'), function (b) {
      return b.getAttribute('data-value');
    }).filter(Boolean);
  }
  function sync() {
    if (priceIn && priceOut) priceOut.textContent = (priceIn.textContent || '').replace(/\s+/g, ' ').trim();
    if (variantOut) variantOut.textContent = selectedValues().join(' / ');
    var sg = sizeGroup();
    var noSize = sg && !sg.querySelector('.is-selected');
    var invalid = main.disabled && !main.hasAttribute('data-variant-id') &&
      (main.textContent || '').trim() === (main.getAttribute('data-label-invalid') || '').trim();
    if (noSize || invalid) {
      mode = 'choose';
      btn.disabled = false;
      btn.classList.add('is-choose');
      label.textContent = bar.getAttribute('data-choose-label');
    } else {
      mode = main.disabled ? 'blocked' : 'add';
      btn.disabled = main.disabled;
      btn.classList.remove('is-choose');
      var mainLabel = main.querySelector('[data-sc-add-label]');
      label.textContent = (mainLabel ? mainLabel.textContent : main.textContent).trim();
    }
  }
  function overlayOpen() {
    var b = document.body;
    if (b.classList.contains('overflow-hidden') || b.classList.contains('sc-gallery-modal-open')) return true;
    if (b.style.position === 'fixed') return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return true;
    var modals = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < modals.length; i++) {
      var m = modals[i];
      if (bar.contains(m) || m.offsetParent === null) continue;
      var r = m.getBoundingClientRect();
      // Conta solo se davvero sullo schermo (il pannello del carrello chiuso resta fuori schermo con aria-modal).
      if (r.width > 0 && r.height > 0 && r.left < window.innerWidth && r.right > 0 && r.top < window.innerHeight && r.bottom > 0 &&
          getComputedStyle(m).visibility !== 'hidden') return true;
    }
    var cookie = document.getElementById('shopify-pc__banner');
    if (cookie && cookie.offsetParent !== null && getComputedStyle(cookie).visibility !== 'hidden') return true;
    return false;
  }
  function render() {
    var show = mq.matches && !mainVisible && !overlayOpen();
    if (show) {
      sync();
      if (bar.hidden) { bar.hidden = false; void bar.offsetWidth; }
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
      bar.removeAttribute('inert');
      document.body.classList.add('scs-bar-on');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
      document.body.classList.remove('scs-bar-on');
      if (!mq.matches || reduce.matches) bar.hidden = true;
      else window.setTimeout(function () { if (!bar.classList.contains('is-visible')) bar.hidden = true; }, 300);
    }
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; window.requestAnimationFrame(function () { queued = false; render(); }); }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { mainVisible = e.isIntersecting; });
      schedule();
    }, { threshold: 0 }).observe(main);
  }
  new MutationObserver(function () { if (!bar.hidden) sync(); schedule(); })
    .observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
  if (priceIn) new MutationObserver(function () { if (!bar.hidden) sync(); }).observe(priceIn, { childList: true, subtree: true, characterData: true });
  pdp.querySelectorAll('[data-sc-pdp-option]').forEach(function (g) {
    new MutationObserver(function () { if (!bar.hidden) sync(); }).observe(g, { attributes: true, subtree: true, attributeFilter: ['class'] });
  });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-modal', 'class', 'hidden', 'open'] });
  if (mq.addEventListener) mq.addEventListener('change', schedule);

  btn.addEventListener('click', function () {
    sync();
    if (mode === 'choose') {
      var sg = sizeGroup() || pdp.querySelector('[data-sc-pdp-option]');
      if (sg) {
        sg.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'center' });
        var first = sg.querySelector('button:not([disabled])');
        if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, reduce.matches ? 0 : 400);
      }
      return;
    }
    if (mode !== 'add' || main.disabled || !main.getAttribute('data-variant-id')) return;
    main.click();
  });
  sync();
  render();
})();
